import XLSX from 'xlsx';
let FileSaver = require('file-saver');

function s2ab (s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }
  return buf;
}
export default {
  /**
   * 下载函数
   */
  download: function (data, fileName) { //第一列为标题列
    // let data = [
    //     ["列A", "列B"],
    //     [3,4]
    // ];
    let wopts = {
      bookType: 'xlsx',
      type: 'binary'
    };
    // let fileName = "bill.xlsx";
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const wbout = XLSX.write(wb, wopts);
    FileSaver.saveAs(new Blob([s2ab(wbout)]), fileName); // 保存为文件
  }
};



// WEBPACK FOOTER //
// ./src/service/excelUtil.js